"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function xMinutesAgo(dateStr) {
  var date = new Date(dateStr);
  var dateTime = date.getTime();

  if (isNaN(dateTime)) {
    return dateStr;
  }

  var now = Date.now();
  var deltaInMs = now - dateTime;
  var deltaInMinutes = Math.floor(deltaInMs / 60000);
  var deltaInHours = Math.floor(deltaInMs / 3600000);

  if (deltaInMinutes < 1) {
    return 'Agora a pouco';
  } else if (deltaInMinutes === 1) {
    return 'Um minuto atrás';
  } else if (deltaInHours < 1) {
    return "".concat(deltaInMinutes, " minutos atr\xE1s");
  } else if (deltaInHours === 1) {
    return "Uma hora atr\xE1s";
  } else if (deltaInHours < 5) {
    return "".concat(deltaInHours, " horas atr\xE1s");
  } else if (deltaInHours <= 24) {
    return "Hoje";
  } else if (deltaInHours <= 48) {
    return "Ontem";
  } else if (window.Intl) {
    return new Intl.DateTimeFormat('pt-BR').format(date);
  } else {
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}

var _default = {
  FAILED_CONNECTION_NOTIFICATION: 'Não foi possível conectar',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: 'não pude enviar, {Retry}.',
  SLOW_CONNECTION_NOTIFICATION: 'A conexão está levando mais tempo que o normal.',
  'Chat': 'Bate-papo',
  'Download file': 'Baixar arquivo',
  'Microphone off': 'Microfone desligado',
  'Microphone on': 'Microfone ligado',
  'Listening…': 'Ouvindo…',
  'retry': 'repetir',
  'Retry': '{retry}',
  // Please alter this value if 'Retry' at the beginning of a sentence is written differently than at the end of a sentence.
  'Send': 'Enviar',
  'Sending': 'enviando',
  'Speak': 'Falar',
  'Starting…': 'Iniciando…',
  'Tax': 'Imposto',
  'Total': 'Total',
  'Type your message': 'Digite sua mensagem',
  'Upload file': 'Subir arquivo',
  'VAT': 'VAT',
  'X minutes ago': xMinutesAgo
};
exports.default = _default;